// SkeletonBox.jsx
import React from "react";

export default function SkeletonBox({ className = "", style = {} }) {
  return (
    <div
      className={`animate-pulse bg-gray-200 rounded-md ${className}`}
      style={style}
    ></div>
  );
}
